import getFirebase from 'helper/getFirebase';
import { LiveClassEventType } from '../utils/consts';
import createLiveClassDoc from '../utils/createLiveClassDoc';

export default async function addCompletionEvent(classId, userId, companyId, contentId, cardId) {
  const { firebaseDB } = await getFirebase();
  const liveClassCollection = firebaseDB.collection('live-class-events');
  const type = LiveClassEventType.CARD_COMPLETE;
  const docId = `${classId}_${type}_${userId}_${cardId}`;

  const currentDocument = await liveClassCollection.doc(docId).get();
  if (currentDocument.exists) {
    return Promise.resolve();
  }

  return liveClassCollection
    .doc(docId)
    .set(createLiveClassDoc(type, { classId, userId, companyId, contentId, cardId }));
}
